import React, { useState, useEffect, useRef, useContext } from 'react';
import { Modal, message } from 'antd';
import { AppContext } from 'App.context';
import { ApiContext } from 'utils/networking/Api.context';
import TwoFactorInput from 'Components/common/Welcome/ValidateLogin/components/TwoFactorInput/TwoFactorInput';
import styles from './TwoFactorModal.styles';

let show2FAModalFn = null;

export function TwoFactorModal() {
  const {
    appState,
    appActions: { translate, getSelectedLanguage },
  } = useContext(AppContext);

  const [state, setState] = useState({
    visible: false,
    loading: false,
    sessionUuid: '',
    inputResetCounter: 0,
  });

  const { API } = useContext(ApiContext);

  const resolverRef = useRef(null);

  function updateState(object) {
    setState(prev => ({ ...prev, ...object }));
  }

  useEffect(() => {
    show2FAModalFn = async () => {
      if (appState.superUser) {
        console.info('2FA Exception - Super User');
        return Promise.resolve(true);
      }

      const { sessionUuid } = await API.send2fa(getSelectedLanguage().id);
      return new Promise(resolve => {
        updateState({
          visible: true,
          loading: false,
          sessionUuid: sessionUuid,
          inputResetCounter: prev => prev.inputResetCounter + 1,
        });
        resolverRef.current = resolve;
      });
    };
  }, []);

  const close = result => {
    updateState({ visible: false, loading: false, sessionUuid: '', inputResetCounter: 0 });
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  };

  const handleVerify = async code => {
    updateState({ loading: true });
    try {
      const isValid = await API.confirm2fa({ code: code, sessionUuid: state.sessionUuid });

      if (isValid) {
        close(true);
      } else {
        message.error(translate('twoFactor.codeErrorMessage'));
      }
    } catch {
      message.error(translate('twoFactor.genericErrorMessage'));
    } finally {
      updateState(prev => ({
        loading: false,
        inputResetCounter: prev.inputResetCounter + 1,
      }));
    }
  };

  const onCodeChange = async code => {
    await handleVerify(code);
  };

  return (
    <Modal
      title={<span style={styles.title}>{translate('twoFactor.title')}</span>}
      open={state.visible}
      footer={null}
      maskClosable={false}
      onCancel={() => close(false)}
      centered
      zIndex={999999}
      getContainer={() => document.body}
    >
      <span style={styles.text}>{translate('twoFactor.description')}</span>
      <TwoFactorInput onValidCode={onCodeChange} reset={state.inputResetCounter} />
    </Modal>
  );
}

export function show2FAModal() {
  if (typeof show2FAModalFn === 'function') {
    return show2FAModalFn();
  } else {
    return Promise.resolve(false);
  }
}
